module.exports = __webpack_public_path__ + "static/img/word.2a8a472.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icones/word.png
// module id = AswE
// module chunks = 1